// Change the third column to Transaction Limit later
export const INTERNAL_USERS_TABLE_HEADINGS = ['User', 'Role', '', '', ''];

export const TransactionFrequencyMappings = {
  daily: 'day',
  weekly: 'week',
  monthly: 'month',
};
